import { FunnelQuestion } from '@pflegia/types/api/funnel/questions';

import { FunnelEventMarketing } from './funnel-event-marketing';

export type PflegiaFunnelQuestion = Exclude<
  FunnelQuestion,
  FunnelQuestion.Registration | FunnelQuestion.PotentialJobsPreview | FunnelQuestion.CityAreas
>;

export const funnelQuestionToFunnelEventMarketing: Record<PflegiaFunnelQuestion, FunnelEventMarketing> = {
  [FunnelQuestion.NursingAreaWorking]: FunnelEventMarketing.NursingAreaChosen,
  [FunnelQuestion.EmployeeType]: FunnelEventMarketing.EmployerTypeChosen,
  [FunnelQuestion.JobTitle]: FunnelEventMarketing.DesiredPositionChosen,
  [FunnelQuestion.PositionDesired]: FunnelEventMarketing.DesiredPositionChosen,
  [FunnelQuestion.PositionDeputy]: FunnelEventMarketing.IsDeputyPositionChosen,
  [FunnelQuestion.DQualification]: FunnelEventMarketing.HasNursingApprenticeshipAnswered,
  [FunnelQuestion.CQualification]: FunnelEventMarketing.HasApprenticeshipAnswered,
  [FunnelQuestion.BQualification]: FunnelEventMarketing.Has3YearExamAnswered,
  [FunnelQuestion.AQualification]: FunnelEventMarketing.HasCertificationAnswered,
  [FunnelQuestion.DQualificationRecognition]: FunnelEventMarketing.RecognitionUpdated,
  [FunnelQuestion.CQualificationRecognition]: FunnelEventMarketing.RecognitionUpdated,
  [FunnelQuestion.BQualificationRecognition]: FunnelEventMarketing.RecognitionUpdated,
  [FunnelQuestion.JobQualificationRecognition]: FunnelEventMarketing.RecognitionUpdated,
  [FunnelQuestion.YearsOfExperience]: FunnelEventMarketing.YearsOfExperienceAnswered,
  [FunnelQuestion.FurtherQualifications]: FunnelEventMarketing.HasFurtherQualificationsAnswered,
  [FunnelQuestion.Qualifications]: FunnelEventMarketing.FurtherQualificationsChosen,
  [FunnelQuestion.Departments]: FunnelEventMarketing.DesiredUnitsChosen,
  [FunnelQuestion.HaveDriverLicense]: FunnelEventMarketing.HasDriversLicenseAnswered,
  [FunnelQuestion.Locations]: FunnelEventMarketing.LocationChosen,
  [FunnelQuestion.GermanSpeakingLevel]: FunnelEventMarketing.GermanLevelChosen,
  [FunnelQuestion.PermanentOrTemporary]: FunnelEventMarketing.EmploymentRelationshipChosen,
  [FunnelQuestion.EmploymentType]: FunnelEventMarketing.EmploymentScheduleChosen,
  [FunnelQuestion.CanStartOn]: FunnelEventMarketing.CanStartOnChosen,
  [FunnelQuestion.JobYearsOfExperience]: FunnelEventMarketing.JobYearsOfExperienceAnswered,
  [FunnelQuestion.CvFiles]: FunnelEventMarketing.CvFilesUploaded,
  [FunnelQuestion.NameAndEmail]: FunnelEventMarketing.RegistrationStep1Completed,
  // not used mappings
  [FunnelQuestion.PersonalData]: FunnelEventMarketing.PersonalDataProvided,
  [FunnelQuestion.PhoneNumber]: FunnelEventMarketing.PhoneNumberProvided,
  [FunnelQuestion.ExternalRegistration]: FunnelEventMarketing.ExternalRegistrationCompleted,
  [FunnelQuestion.JobQualification]: FunnelEventMarketing.JobQualificationProvided,
  [FunnelQuestion.CaregiverQualification]: FunnelEventMarketing.CaregiverQualificationAnswered,
  [FunnelQuestion.QualificationRecognition]: FunnelEventMarketing.RecognitionUpdated,
  // Praxia
  [FunnelQuestion.HighlightJobTitle]: FunnelEventMarketing.DesiredPositionChosen,
};
